import { render, staticRenderFns } from "./ChatMessageEdit.vue?vue&type=template&id=b3ee80d8&scoped=true"
import script from "./ChatMessageEdit.vue?vue&type=script&lang=js"
export * from "./ChatMessageEdit.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageEdit.vue?vue&type=style&index=0&id=b3ee80d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ee80d8",
  null
  
)

export default component.exports